// Library Class
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription, forkJoin } from 'rxjs';
import { Router } from '@angular/router';
// Class
import { MasterConstants } from '../../../../common/constants/master-constants';
import { FilterOption } from '../../../../common/components/filter/filter-model';
import { ControlType } from '../../../../common/components/filter/filter-enum';
import { CommonService } from './../../../../services/common/common.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
// Service Class
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { ExcelService } from './../../../../services/infrastructure/excel.service';
import { PlotSeedService } from '../../../../services/seed/plot-seed.service';
import { PlotSeedReleaseService } from '../../../../services/seed/plot-seed-release.service';
import { ToastrService } from 'ngx-toastr';
import { PlotSeedLandingReleaseFilterVM } from '../../../../models/plot-seed-landing-release-filterVM';

@Component({
  selector: 'app-plot-seed-release-landing',
  templateUrl: './plot-seed-release-landing.component.html',
  styleUrl: './plot-seed-release-landing.component.scss'
})
export class PlotSeedReleaseLandingComponent implements OnInit, AfterViewInit, OnDestroy {
  headerCompany = MasterConstants.US_COMPANYCODE;
  headerYear: any;
  validateEvolveData: any;
  ddlAccounts: any[] = [];
  userMenuAccessList: any;
  readOnlyAccess = false;
  editFullAccess = false;
  filterOptionsData: Array<FilterOption>;
  showCreateButton = false;
  isEvolveAccountRestriction = false;
  subscription = new Subscription();
  masterConstants = MasterConstants;
  plotSeedDataSource: MatTableDataSource<any>;
  @ViewChild('plotSeedTable', { read: MatSort }) plotSeedSort: MatSort;
  @ViewChild('plotSeedPaginator', { read: MatPaginator }) plotSeedPaginator: MatPaginator;
  plotSeedOrderColumns: string[] = [];
  filter: PlotSeedLandingReleaseFilterVM = new PlotSeedLandingReleaseFilterVM();
  statusList: any = ['ORDER CREATED', 'SUBMITTED', 'CANCELLED', 'ERROR', 'SHIPPED'];
  cropTypeList: any[] = [];
  orderLines: any;
  remainingQtyChk: boolean = false;
  hasOldFilter: Boolean = false;
  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    public excelService: ExcelService,
    private datePipe: DatePipe,
    private commonService: CommonService,
    private plotSeedService: PlotSeedService,
    private toastrService: ToastrService,
    private plotSeedReleaseService: PlotSeedReleaseService
  ) { }

  // ngOnInit
  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      const sessionData = validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
      this.isEvolveAccountRestriction = sessionData.evolveAccountRestriction;
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == MasterConstants.US_COMPANYCODE).userMenuAccessList;
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.PLOT_SEED_RELEASE)) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.PLOT_SEED_RELEASE, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.editFullAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.PLOT_SEED_RELEASE, MasterConstants.USER_ACCESS.EDIT_FULL, this.userMenuAccessList);
          this.showCreateButton = this.editFullAccess;
          if (this.headerYear) {
            this.setFilterAndGridColumn();
            this.setDefaultFilter();
            const oldFilters = this.plotSeedReleaseService.getOldFilters();
            this.hasOldFilter = oldFilters != undefined || oldFilters != null;
            if (this.hasOldFilter) {
              Object.keys(oldFilters).forEach(key => {
                const value = oldFilters[key];

                if (value !== null && value !== undefined && value !== '') {
                  this.filter[key] = value;
                }
              });
            }
            this.plotSeedReleaseService.setOldFilters(null);
            this.getGridData(true);
          }
        }
        else {
          this.router.navigate(['/cc/landing-data']);
        }
      }
    }
  }


  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setPlotSummaryTableHeight();
  }


  // set account table height
  setPlotSummaryTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.mat-mdc-tab-header').outerHeight() - $('.fulfill-top-sec').outerHeight() - $('.plotSeedHeader').outerHeight() - $('.plotSeedFilterSection').outerHeight() - 130;
      $('.activeReturnRequest').css('max-height', templateHeight + 'px');
    }, 100);
  }

  // Set Filter and Grid Columns
  setFilterAndGridColumn() {
    this.filterOptionsData = [
      { label: 'Sales Manager Account', key: 'salesManagerAccountNumberList', controlType: ControlType.Text },
      { label: 'Sales Manager Name', key: 'salesManagerAccountNameList', controlType: ControlType.Text },
      { label: 'Account Name', key: 'accountNameList', controlType: ControlType.Text },
      { label: 'Account Number', key: 'accountNumberList', controlType: ControlType.Text },
      { label: 'Parent Account Number', key: 'parentAccountNumberList', controlType: ControlType.Text },
      { label: 'Parent Name', key: 'parentAccountNameList', controlType: ControlType.Text },
      { label: 'Order Number', key: 'orderHeaderIdList', controlType: ControlType.Text },
      { label: 'Product Line', key: 'cropTypeCode', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id', isMultiSelect: true },
      { label: 'Hybrid Varierty', key: 'brandList', controlType: ControlType.Text },
      { label: 'Maturity', key: 'maturity', controlType: ControlType.MultiDropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id', isMultiSelect: false },
      { label: 'Status', key: 'status', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id', isMultiSelect: true },
    ];
    this.plotSeedOrderColumns = ['orderHeaderID', 'salesManagerAccountNumber', 'salesManagerAccountName', 'shipToAccount', 'accountName', 'parentAccountNumber', 'parentName', 'productLine', 'brand', 'marketingBrand', 'maturity', 'orderDate', 'orderQty', 'releasedQty', 'remQty', 'status'];
  }

  // Set Drop down values for filter
  setDropDownValues() {
    this.loaderService.setLoaderStatus(true);
    const forkJoinApIs = [];
    forkJoinApIs.push(this.plotSeedService.getPlotSeedProductLines());
    forkJoinApIs.push(this.plotSeedService.getMaturityData());
    forkJoinApIs.push(this.plotSeedService.getPlotSeedStatusList());
    this.subscription.add(forkJoin(forkJoinApIs).subscribe((result: any[]) => {
      if (result && result.length > 0) {
        this.cropTypeList = result[0] && result[0].length > 0
            ? [
              { id: '', value: 'Select All' },
             ...result[0].map(item => ({
                id: item.id,
                value: `${item.value}`
              }))
            ]
            : [];
        this.filterOptionsData.find(x => x.key === 'cropTypeCode').controlData = this.cropTypeList;
        let maturityList = result[1] && result[1].length > 0 ? result[1].map(item => ({
          id: item.id,
          value: `${item.id}`
        })) : [];
        this.filterOptionsData.find(x => x.key === 'maturity').controlData = maturityList;
        this.filterOptionsData.find(x => x.key === 'status').controlData = result[2] && result[2].length > 0 ? result[2] : [];
        if (this.hasOldFilter) {
          this.filterOptionsData.find(x => x.key === 'salesManagerAccountNumberList').filterValue = this.filter.salesManagerAccountNumberList;
          this.filterOptionsData.find(x => x.key === 'salesManagerAccountNameList').filterValue = this.filter.salesManagerAccountNameList;
          this.filterOptionsData.find(x => x.key === 'accountNameList').filterValue = this.filter.accountNameList;
          this.filterOptionsData.find(x => x.key === 'accountNumberList').filterValue = this.filter.accountNumberList;
          this.filterOptionsData.find(x => x.key === 'parentAccountNumberList').filterValue = this.filter.parentAccountNumberList;
          this.filterOptionsData.find(x => x.key === 'parentAccountNameList').filterValue = this.filter.parentAccountNameList;
          this.filterOptionsData.find(x => x.key === 'orderHeaderIdList').filterValue = this.filter.orderHeaderIdList;
          this.filterOptionsData.find(x => x.key === 'brandList').filterValue = this.filter.brandList;
          this.filterOptionsData.find(x => x.key === 'parentAccountNameList').filterValue = this.filter.parentAccountNameList;
          if (this.filter.status) {
            this.filterOptionsData.find(x => x.key === 'status').filterValue = this.filter.status.split(',').map(s => s.trim());
          }
          if (this.filter.cropTypeCode) {
            this.filterOptionsData.find(x => x.key === 'cropTypeCode').filterValue = this.filter.cropTypeCode.split(',').map(s => s.trim());
          }
          if (this.filter.maturity) {
            this.filterOptionsData.find(x => x.key === 'maturity').filterValue = this.filter.maturity;
            this.filterOptionsData.find(x => x.key === 'maturity').fromFilterValue = this.filter.maturity.fromMaturity;
            this.filterOptionsData.find(x => x.key === 'maturity').toFilterValue = this.filter.maturity.toMaturity;
          }
            this.filterOptionsData = [...this.filterOptionsData];
        }
        this.loaderService.setLoaderStatus(false);
      }
    }));
    
  }


  //getcropTypeList(source) {
  //  let result = [];
  //  const seen = new Set();
  //  for (const item of source) {
  //    if (!seen.has(item.cropTypeCode)) {
  //      seen.add(item.cropTypeCode);
  //      result.push({ id: item.cropTypeCode, value: item.cropTypeDesc });
  //    }
  //  }
  //  result = result.sort((a, b) => a.value.localeCompare(b.value));
  //  return result;
  //}

  // Set default filter values
  setDefaultFilter() {
    this.filter = {
      salesManagerAccountNumberList: null,
      salesManagerAccountNameList: null,
      orderHeaderIdList: null,
      accountNumberList: null,
      accountNameList: null,
      parentAccountNumberList: null,
      parentAccountNameList: null,
      cropTypeCode: null,
      brandList: null,
      maturity: null,
      status: null
   };
  }

  // ngOnDestroy
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // get data for both tabs
  getGridData(isfirstimeload: boolean) {
    var data = {
      isReleaseScreen: true,
      remainingQtyChk: this.remainingQtyChk,
      salesManagerAccountNumberList: this.filter.salesManagerAccountNumberList,
      salesManagerAccountNameList: this.filter.salesManagerAccountNameList,
      orderHeaderIdList: this.filter.orderHeaderIdList,
      accountNumberList: this.filter.accountNumberList,
      accountNameList: this.filter.accountNameList,
      parentAccountNumberList: this.filter.parentAccountNumberList,
      parentAccountNameList: this.filter.parentAccountNameList,
      cropTypeCode: this.filter.cropTypeCode,
      brandList: this.filter.brandList,
      maturity: this.filter.maturity,
      status: this.filter.status
    };
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.plotSeedService.getPlotSeedLandingData(data).subscribe((result: any[]) => {
      const plotSeedOrderList = result && result.length > 0 ? result : [];
      this.plotSeedDataSource = new MatTableDataSource(plotSeedOrderList);
      if (isfirstimeload) {
        this.orderLines = plotSeedOrderList;
        this.setDropDownValues();
      }
      this.plotSeedDataSource.paginator = this.plotSeedPaginator;
      this.plotSeedDataSource.paginator.firstPage();
      this.plotSeedDataSource.sort = this.plotSeedSort;
      if (!isfirstimeload) {
        this.loaderService.setLoaderStatus(false);
      }
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  // Search Action
  filterSearchClick(event) {
    this.filter = event;
    this.setPlotSummaryTableHeight();
    this.getGridData(false);
  }

  // Clear All Action
  filterClearAllClick(event) {
    this.filter = event;
    this.setPlotSummaryTableHeight();
    this.getGridData(false);
  }

  // Navigate to selected order detail
  navigateOrderDetail(obj: any) {
    this.plotSeedReleaseService.setPlotSeedOrderId(+obj.orderHeaderID);
    this.plotSeedReleaseService.setOldFilters(this.filter);
    this.router.navigate(['plot-seed/plot-seed-release-order']);
  }

  createNewRelease() {
    this.plotSeedReleaseService.setOldFilters(this.filter);
    this.router.navigate(['plot-seed/plot-seed-release-order']);
  }

  reviewRelease() {
    this.router.navigate(['/plot-seed/plot-seed-release-review']);
  }

  public export() {
    this.loaderService.setLoaderStatus(true); // Show loader immediately

    this.subscription.add(this.plotSeedService
      .exportToExcel(this.filter)
      .subscribe(
        (result) => {
          if (result) {

            this.plotSeedService.base64toFile(result.base64, result.mimeType, result.fileName);
            this.loaderService.setLoaderStatus(false);
          }
          else {
            this.loaderService.setLoaderStatus(false);
            this.toastrService.error("An error occurred during export.");
          }
        },
        (error) => this.toastrService.error("An error occurred during export.")
      ));
  }
}
